import { useGlobalContext } from 'components/Context/hooks/useGlobalContext';
import { LinksService } from 'service/links/linksService';
import { COLORS } from 'styles/constants';
import { LiquidButton } from '../../LiquidButton';
import { NextLink } from '../../NextLink';
import { Text as Paragraph } from '../../Typography';
import { ImageTextType } from '../types';
import { conditionalClasses } from '@/utils';

interface ICardButton {
  cardData?: ImageTextType;
  buttonVariant?: 'primary' | 'secondary' | 'none';
}

export const CardButton = ({ cardData, buttonVariant }: ICardButton) => {
  const { pathTranslations } = useGlobalContext();
  if (!cardData?.buttonLink?.displayName) {
    return null;
  }

  return (
    <Paragraph className="mx-auto" tag="div" type="lead">
      <NextLink
        href={
          LinksService.getInternalLinks({
            item: cardData?.buttonLink,
            pathTranslations,
            parentLink: cardData?.parentPage,
          }) || cardData?.buttonLink.url
        }
        className={buttonVariant !== 'none' ? 'inline-block' : undefined}
        target={cardData?.buttonLink.openInNewTab ? '_blank' : '_self'}
        rel="noreferrer"
      >
        <span className="sr-only">{cardData.buttonLink.displayName}</span>
        <LiquidButton
          variant={buttonVariant}
          text={cardData?.buttonLink?.displayName}
          height={50}
          width={200}
          color={COLORS.primary}
          textColor={COLORS.white}
          className={conditionalClasses({
            'mt-5': buttonVariant !== 'none',
          })}
        />
      </NextLink>
    </Paragraph>
  );
};
